export default __webpack_public_path__ + "static/images/free_icon.c978d94d.png";